(function () {
    'use strict';

    angular.module("imApp").factory("customerBusCoService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomerBuscos: function (parms) {
                return $ihttp.post({
                    method: 1293,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1295,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
